/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Date of the doctor next availability for an appointment type, null if none
 * @export
 * @interface NextAppointmentTypeAvailability
 */
export interface NextAppointmentTypeAvailability {
    /**
     * 
     * @type {string}
     * @memberof NextAppointmentTypeAvailability
     */
    date?: string;
}

/**
 * Check if a given object implements the NextAppointmentTypeAvailability interface.
 */
export function instanceOfNextAppointmentTypeAvailability(value: object): value is NextAppointmentTypeAvailability {
    return true;
}

export function NextAppointmentTypeAvailabilityFromJSON(json: any): NextAppointmentTypeAvailability {
    return NextAppointmentTypeAvailabilityFromJSONTyped(json, false);
}

export function NextAppointmentTypeAvailabilityFromJSONTyped(json: any, ignoreDiscriminator: boolean): NextAppointmentTypeAvailability {
    if (json == null) {
        return json;
    }
    return {
        
        'date': json['date'] == null ? undefined : json['date'],
    };
}

export function NextAppointmentTypeAvailabilityToJSON(json: any): NextAppointmentTypeAvailability {
    return NextAppointmentTypeAvailabilityToJSONTyped(json, false);
}

export function NextAppointmentTypeAvailabilityToJSONTyped(value?: NextAppointmentTypeAvailability | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'date': value['date'],
    };
}

